export const OPERATOR = 'operator';
export const RESTAURATEUR = 'restaurateur';

export const OPERATOR_HOME = '/op';
export const RESTAURATEUR_HOME = '/rest';
